
export enum SubscriptionType {
    Preprocessing = 'preprocessing',
    Analyzing = 'analyzing',
    Prediction = 'prediction',
}
